import React from 'react';

const SelectableRow = ({ children, onClick }) => (
  <tr
    onClick={onClick}
    className="border-b cursor-pointer hover:bg-gray-50 text-sm
                   text-left text-gray-bg4 whitespace-nowrap h-12 md:h-16"
  >
    {children}
  </tr>
);

export default SelectableRow;
